import type { DocusignTemplate } from 'src/interfaces/docusignTemplate'

/**
 * In-memory search over the DocuSign templates list. Returns the input array by reference for an
 * empty query so an untouched search box does not churn the caller's `useMemo`.
 *
 * `docusignTemplateId` is searchable on purpose: an admin holding an id from DocuSign wants to
 * know whether it is already registered for this customer.
 */
export const filterDocusignTemplates = (
  templates: DocusignTemplate[],
  search: string,
): DocusignTemplate[] => {
  const normalizedSearch = search.trim().toLowerCase()

  if (normalizedSearch === '') {
    return templates
  }

  return templates.filter((template) => {
    // `title` and `description` are nullable in the DB — see the design's §2.1.
    const haystack = [template.title ?? '', template.description ?? '', template.docusignTemplateId]

    return haystack.some((value) => {
      return value.toLowerCase().includes(normalizedSearch)
    })
  })
}
